export default __webpack_public_path__ + "static/media/ekatralogo.8ab9fa7f.svg";